import { Grant } from "../../types/Grant";
import { AllocationMode } from "../../store/useAllocationMatrixStore";
import { formatCurrency, getCurrencyType } from "../../utils/currencyFormatter";
import { VStack } from "../../components/utils";

interface BulkGrantMatrixCellProps {
  grant: Grant;
  matrixName?: string;
}

export function BulkGrantMatrixCell({
  grant,
  matrixName,
}: BulkGrantMatrixCellProps) {
  const currencyType = getCurrencyType();

  if (!grant.allocationMatrixId) {
    return <span className="text-xs text-gray-light">—</span>;
  }

  const rule = grant.matchedRule as any;
  if (!rule) {
    return (
      <div className="text-xs font-medium text-primaryText break-words">
        {matrixName || "—"}
      </div>
    );
  }

  const isValueMode = rule.allocationMode === AllocationMode.ABSOLUTE_VALUE;

  const fmtQuantum = (value: number | null | undefined): string => {
    if (value === null || value === undefined || Number.isNaN(value))
      return "—";
    if (isValueMode) return formatCurrency(value, currencyType);
    return `${value.toLocaleString()} Options`;
  };

  return (
    <VStack className="gap-1 py-2 w-full overflow-hidden">
      <div className="text-xs font-medium text-primaryText break-words whitespace-normal w-full">
        {matrixName || "—"}
      </div>
      <VStack className="gap-0.5 text-[11px]">
        {rule.quantumRecommended != null && (
          <div className="flex justify-between gap-2">
            <span className="text-gray-light">Recommended:</span>
            <span className="font-semibold text-primaryText">
              {fmtQuantum(rule.quantumRecommended)}
            </span>
          </div>
        )}
        {rule.quantumMax != null && (
          <div className="flex justify-between gap-2">
            <span className="text-gray-light">Max:</span>
            <span className="font-semibold text-primaryText">
              {fmtQuantum(rule.quantumMax)}
            </span>
          </div>
        )}
      </VStack>
    </VStack>
  );
}
